<template>
  <div>
    <NameServerList />

    <div class="row">
      <div class="col-md-4">
        <v-text-field
          class="font-size-sm form-control pl-1 pt-1 search-text-field my-3"
          :placeholder="$t('global.search')"
          prepend-icon="search"
          v-model="search"
          single-line
          dense
          flat
          solo
          hide-details
        ></v-text-field>
      </div>
    </div>

    <!-- List Table -->
    <List
      :header="header"
      :data="getData"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
    >
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:item.content="{ item }">
        <span v-if="item.content" :id="`item-content-${item.id_ref}`">
          {{ item.content.slice(0, 25) }}
        </span>
        <span v-else>N/A</span>

        <b-tooltip
          v-if="item.content"
          :target="`item-content-${item.id_ref}`"
          triggers="hover"
          placement="top"
        >
          {{ item.content }}
        </b-tooltip>
      </template>

      <template v-slot:item.running="{ item }">
        {{
          item.dnsService && item.dnsService.data
            ? item.dnsService.data.name
            : '-'
        }}
      </template>

      <template v-slot:item.action="{ item }">
        <b-dropdown
          class="actions-button nomaxh"
          variant="dark"
          :text="$t('global.actions')"
        >
          <b-dropdown-item @click.native="updateContent(item)">{{
            $t('servers.updateContent')
          }}</b-dropdown-item>
          <b-dropdown-item @click.native="updateTTL(item)">{{
            $t('servers.updateTTL')
          }}</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            class="dropdownAlertLabel"
            @click.native="terminate(item)"
            >{{ $t('servers.terminate') }}</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </List>

    <!-- Create Popup -->
    <DetailModal
      :title="$t(dynamicOperationComponentTitle)"
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <component
        v-if="dynamicOperationComponent != ''"
        :is="dynamicOperationComponent"
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :selected="selected"
        :detailData="detailData"
        :dns_service_id="dns_service_id"
      />
    </DetailModal>

    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'DNSDetail',
  data() {
    return {
      detailData: null,
      dns_service_id: '',
      search: '',
      filters: '',
      showDetail: false,
      loading: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        {
          text: 'servers.recordType',
          value: 'type',
        },
        {
          text: 'servers.record',
          value: 'name',
          size: '2fr',
        },
        {
          text: 'servers.content',
          value: 'content',
          size: '2fr',
        },
        {
          text: 'servers.ttl',
          value: 'ttl',
        },
        { text: 'global.actions', value: 'action' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      dynamicOperationComponentTitle: '',
      dynamicOperationComponent: '',
      selected: '',
    }
  },
  computed: {
    getData() {
      return this.data.filter((f) =>
        f.name.toLowerCase().includes(this.search.toLowerCase())
      )
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'servers.advancedDns',
        route: '/networking/domain-name-service',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'global.networking',
        },
        {
          title: 'servers.advancedDns',
          route: '/networking/domain-name-service',
        },
        { title: 'global.detail' },
      ],
      showSearch: false,
      detailPlaceholder: this.$t('servers.addRecord'),
    })

    EventBus.$on(`subHeaderDetailOpen`, this.listener)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderDetailOpen`, this.listener)
  },
  created() {
    this.getDnsServiceId()
    //this.getList()
  },
  methods: {
    listener(payload) {
      this.dynamicOperationComponentTitle = 'servers.addRecord'
      this.dynamicOperationComponent = 'AddRecord'
      this.showDetail = true
    },
    getDnsServiceId() {
      this.loading = true
      ApiService.get(`domains/${this.$route.params.id}`)
        .then(({ data }) => {
          if (data.data) {
            this.detailData = data.data
            this.dns_service_id = data.data.dns_service_id
            this.getList()
          }
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `packetbender/dns/services/${this.dns_service_id}/domains/${
        this.$route.params.id
      }/records?position=id|descpage=${current_page ? current_page : 1}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeDetail() {
      this.showDetail = false
    },
    updateContent(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.updateContent'
      this.dynamicOperationComponent = 'UpdateContent'
      this.showDetail = true
    },
    updateTTL(item) {
      this.selected = item
      this.dynamicOperationComponentTitle = 'servers.updateTTL'
      this.dynamicOperationComponent = 'UpdateTTL'
      this.showDetail = true
    },
    terminate(item) {
      this.deleteOperationUrl = `packetbender/dns/services/${this.dns_service_id}/domains/${this.$route.params.id}/records/${item.id_ref}`
      this.$bvModal.show('modal-deleteOperation')
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.$generateToast(this, 'success', this.$t('global.successful'))
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    UpdateContent: () => import('@/components/networking/dns/UpdateContent'),
    UpdateTTL: () => import('@/components/networking/dns/UpdateTTL'),
    AddRecord: () => import('@/components/networking/dns/AddRecord'),
    NameServerList: () => import('@/components/NameServerList'),
  },
}
</script>
